(ns ballot-scout-v2-frontend.voter-lookup.views.search
  (:require
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.components.search :refer [clear-button]]
   [ballot-scout-v2-frontend.util :as util :refer [remove-empty-values trim-values]]
   [clojure.string :as str]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn search-form
  "Wrap text search bar in a form with search button and filter toggle button."
  [text-input-element search-fn show-filters-dropdown?]
  [:div
   [:form {:class "field is-grouped"
           :on-submit search-fn}
    text-input-element

    [:div {:class "control"}
     [:a {:class ["filters-toggle" "button" "is-primary" "is-outlined"]
          :on-click (fn [e]
                      (.preventDefault e)
                      (-> e .-target .blur)
                      (swap! show-filters-dropdown? not))}
      (if @show-filters-dropdown?
        [:<>
         [icon ::icon/xmark {:class "pr-2"}]
         [:span "Hide Filters"]]
        [:<>
         [icon ::icon/filter {:class "pr-2"}]
         [:span "Show Filters"]])]]

    [:div {:class "control"}
     [:button {:class "button is-primary"
               :type "submit"}
      [icon ::icon/search {:class "mr-2"}]
      "Search"]]]])

(defn name-search-form [lookup-route get-lookup-route-params state
                        show-filters-dropdown?
                        name-search-value address-1-search-value city-state-zip-search-value]
  (r/with-let [search-by-name!
               (fn [e]
                 (.preventDefault e)
                 (reset! address-1-search-value nil)
                 (reset! city-state-zip-search-value nil)
                 (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate
                               lookup-route
                               (get-lookup-route-params)
                               (-> @state
                                   (dissoc :page :page-size :voter.address-1 :voter.city-state-zip)
                                   (assoc :query @name-search-value)
                                   remove-empty-values)]))]
    [search-form
     [:div {:class "control is-expanded button-in"}
      [:input {:class "input"
               :aria-label "Search by name or ID"
               :value @name-search-value
               :on-change #(reset! name-search-value (-> % .-target .-value))
               :placeholder "Voter Name or ID"}]
      (when-not (str/blank? @name-search-value)
        [link {:route-name lookup-route
               :params (get-lookup-route-params)
               :query (-> @state (dissoc :page :page-size :query) remove-empty-values)}
         [clear-button #(reset! name-search-value nil)]])]
     search-by-name!
     show-filters-dropdown?]))

(defn address-search-form [lookup-route get-lookup-route-params state
                           show-filters-dropdown?
                           name-search-value address-1-search-value city-state-zip-search-value]
  (r/with-let [search-by-address!
               (fn [e]
                 (.preventDefault e)
                 (reset! name-search-value nil)
                 (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate
                               lookup-route
                               (get-lookup-route-params)
                               (-> @state
                                   (dissoc :page :page-size :query)
                                   (assoc :voter.address-1 @address-1-search-value
                                          :voter.city-state-zip @city-state-zip-search-value)
                                   remove-empty-values
                                   trim-values)]))]
    [search-form
     [:div {:class "control is-expanded button-in"}
      [:div {:class "field-body columns m-0"}
       [:div {:class "column is-three-fifths p-0"}
        [:input {:class "input address-input"
                 :aria-label "Search by voter street address"
                 :value @address-1-search-value
                 :on-change #(reset! address-1-search-value (-> % .-target .-value))
                 :placeholder "Voter Address"}]]
       [:div {:class "column is-two-fifths p-0"}
        [:input {:class "input city-state-zip-input"
                 :aria-label "Search by voter coty, state, or zip code"
                 :value @city-state-zip-search-value
                 :on-change #(reset! city-state-zip-search-value (-> % .-target .-value))
                 :placeholder "City, State, or Zip"}]]]
      (when-not (and (str/blank? @address-1-search-value)
                     (str/blank? @city-state-zip-search-value))
        [link {:route-name lookup-route
               :params (get-lookup-route-params)
               :query (-> @state (dissoc :page :page-size :voter.address-1 :voter.city-state-zip) remove-empty-values)}
         [clear-button #(do
                          (reset! address-1-search-value nil)
                          (reset! city-state-zip-search-value nil))]])]
     search-by-address!
     show-filters-dropdown?]))